import api from '@/api'
import Axios from 'axios'


let sectionTitles = {
  1: "My Interests",
  2: "My Work Experience",
  3: "My Thank You Video"
}


export default {
  namespaced: true,
  state: {
    videos: [],
    uploads: [],
    links: [],
  },
  getters: {
    share_url: (state, getters, rootState) => {
      if (!rootState.account.account) {
        return "/"
      }
      return `/profile/${rootState.account.account.uid}` || "/"
    },
    videoTitle: () => (section) => {
      return sectionTitles[section]
    },
    video: (state) => (section) => {
      return state.videos.filter(video => {
        return video.section === section
      }).sort((a, b) => {
        if (a.id < b.id) {
          return 1
        }
        if (a.id > b.id) {
          return -1
        }
        return 0
      })[0]
    },
    upload: (state) => (section) => {
      return state.uploads.filter(upload => {
        return upload.section === section
      }).sort((a, b) => {
        if (a.id < b.id) {
          return 1
        }
        if (a.id > b.id) {
          return -1
        }
        return 0
      })[0]
    },
    links: (state) => {
      return state.links.sort((a, b) => {
        if (a.id < b.id) {
          return 1
        }
        if (a.id > b.id) {
          return -1
        }
        return 0
      })
    }
  },
  mutations: {
    loaded_videos: function(state, data) {
      state.videos = data
    },
    loaded_links: function(state, data) {
      state.links = data
    },
    deleted_video: function(state, video) {
      state.videos = state.videos.filter(v => {
        return v.id !== video.id
      })
    },
    deleted_link: function(state, link) {
      state.links = state.links.filter(v => {
        return v.id !== link.id
      })
    },
    added_link: function(state, link) {
      state.links.push(link)
    }
  },
  actions: {
    load: async function(context) {
      await Promise.all([context.dispatch('loadVideos'), context.dispatch('loadLinks')])
    },
    loadVideos: async function(context) {
      let videos = await api({
        method: "GET",
        url: '/account/user/profile-videos'
      })
      context.commit('loaded_videos', videos)
    },
    loadLinks: async function(context) {
      let links = await api({
        method: "GET",
        url: '/account/user/profile-links'
      })
      context.commit('loaded_links', links)
    },
    createLink: async function(context, url) {
      await api({
        method: "POST",
        url: `/account/user/profile-links/`,
        data: {
          url: url
        }
      })
      context.dispatch('loadLinks')
    },
    updateLink: async function(context, options) {
      await api({
        method: "POST",
        url: `/account/user/profile-links/${options.link.id}`,
        data: options.update
      })
    },
    deleteLink: async function(context, link) {
      await api({
        method: "DELETE",
        url: `/account/user/profile-links/${link.id}`
      })
      context.commit('deleted_link', link)
    },
    updateVideo: async function(context, options) {
      await api({
        method: "POST",
        url: `/account/user/profile-videos/${options.video.id}`,
        data: options.update
      })
    },
    deleteVideo: async function(context, video) {
      await api({
        method: "DELETE",
        url: `/account/user/profile-videos/${video.id}`
      })
      context.commit('deleted_video', video)
    },
    uploadVideo: async function(context, options) {

      let upload_url = await api({
        method: "POST",
        url: `/account/upload-url`,
        data: {
          file: {
            name: options.file.name,
            size: options.file.size,
            type: options.file.type
          },
          key: `profile-videos/${options.section}`
        }
      })
      let upload = {
        progress: 0,
        section: options.section
      }
      context.state.uploads.push(upload)

      var upload_options = {
        headers: {
          'Content-Type': options.file.type,
          'x-amz-acl': 'public-read'
        },
        'Metadata': {
          'Content-Disposition': 'attachment'
        },
        onUploadProgress: function(progressEvent) {
          console.log(progressEvent)
          upload.progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
        }.bind(this)
      };
      await Axios.put(upload_url, options.file, upload_options)

      await api({
        method: "POST",
        url: `/account/user/profile-videos`,
        data: {
          url: upload_url.split("?")[0],
          file_name: options.file.name,
          section: options.section
        }
      })
      await context.dispatch('load')
      context.state.uploads = context.state.uploads.filter(u => {
        return u !== upload
      })



    }
  },
}
